import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import RegistrationOption from "./registration_option";
import AddOnList from "./add_on_list";

const OpenRegistrationLayout = () => {
  const registration_type = useSelector(state => state.registration_type);
  const addons = useSelector(state => state.addons);
  const metadatas = useSelector(state => state.metadatas);

  useEffect(() => {
    window.__REGISTRATION_STATE__ = {
      registration_type: registration_type,
      addons: addons,
      metadatas: metadatas
    };

    const selectedType = document.querySelector('input[name="payment_type"]:checked');
    if (selectedType && selectedType.value === 'check_in') {
      const saveButton = document.querySelector('input.save_registration_form');
      if (saveButton) {
        saveButton.disabled = !registration_type?.name;
      }
    }
  }, [registration_type, addons, metadatas]);

  return (
    <div className="open-registration-layout-wrapper">
      <div className="registration-flex-container">
        <RegistrationOption />
        <AddOnList />
      </div>
    </div>
  );
}

export default OpenRegistrationLayout;